// extracted by mini-css-extract-plugin
module.exports = {"otherProductModule":"OtherProductModule_otherProductModule__SBK5Q"};